import type { ErrorDisplayProps } from '@backstage/frontend-plugin-api';
import { Alert, Button } from '@internal/kern-ux';

/**
 * KERN error display for a failing extension.
 *
 * Shows the error message in plain text — BITV requires errors to be named, not only
 * marked by colour — and offers a retry button.
 */
export const KernErrorDisplay = ({
  plugin,
  error,
  resetError,
}: ErrorDisplayProps) => (
  <Alert variant="danger">
    <Alert.Header
      hasIcon
      title={
        plugin?.id
          ? `Fehler im Bereich „${plugin.id}“`
          : 'Es ist ein Fehler aufgetreten'
      }
    />
    <Alert.Body>
      <p className="kern-body">{error?.message ?? 'Unbekannter Fehler.'}</p>
      <Button
        type="button"
        variant="secondary"
        text="Erneut versuchen"
        onClick={resetError}
      />
    </Alert.Body>
  </Alert>
);
